import { useQuery as c } from "@tanstack/vue-query";
import { computed as s, toValue as o } from "vue";
const n = ["target-group"], p = {
  all: n,
  byCampaign: (r) => [...n, "campaign", r],
  list: (r) => [...n, "campaign", r, "list"],
  detail: (r, t) => [...n, "campaign", r, "detail", t]
}, y = (r, t, a) => {
  const u = s(() => p.list(o(t).campaignId));
  return c({
    ...a,
    queryKey: u,
    queryFn: async () => {
      const e = o(t);
      return r.targetGroup.findAll({ campaignId: e.campaignId });
    }
  });
}, d = (r, t, a) => {
  const u = s(() => {
    const e = o(t);
    return p.detail(e.campaignId, e.targetGroupId);
  });
  return c({
    ...a,
    queryKey: u,
    queryFn: async () => {
      const e = o(t);
      return r.targetGroup.findOne({ targetGroupId: e.targetGroupId });
    }
  });
}, m = async (r, t, a) => {
  await r.prefetchQuery({
    queryKey: p.list(a.campaignId),
    queryFn: async () => t.targetGroup.findAll(a)
  });
}, G = async (r, t, a) => {
  await r.prefetchQuery({
    queryKey: p.detail(a.campaignId, a.targetGroupId),
    queryFn: async () => t.targetGroup.findOne({ targetGroupId: a.targetGroupId })
  });
};
export {
  G as prefetchTargetGroup,
  m as prefetchTargetGroupList,
  p as targetGroupKeys,
  d as useTargetGroup,
  y as useTargetGroupList
};
//# sourceMappingURL=queries.js.map
